import type { NavIconName } from './nav-items'

const paths: Record<NavIconName, string> = {
  markets: 'M4 19V5m0 14h16M8 15V9m4 6V7m4 8v-3',
  trade: 'M3 12h4l3-8 4 16 3-8h4',
  portfolio:
    'M4 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7Zm0 3h16',
  orders: 'M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01',
  deposit:
    'M12 3v12m0 0l-4-4m4 4l4-4M5 19h14',
  withdraw:
    'M12 21V9m0 0l-4 4m4-4l4 4M5 5h14',
  calendar:
    'M8 3v3M16 3v3M4 9h16M5 5h14a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Zm3 8h.01M12 13h.01M16 13h.01M8 17h.01M12 17h.01',
  news: 'M5 5h11a2 2 0 0 1 2 2v12H7a2 2 0 0 1-2-2V5Zm0 0v12a2 2 0 0 0 2 2h12M8 9h6M8 13h4',
  copy: 'M8 8V6a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2M6 8h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2Z',
  analysis:
    'M4 19V5m0 14h16M7 15l3-4 3 2 4-6',
  settings:
    'M12 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm7.5-3.5a7.4 7.4 0 0 0-.1-1.1l2-1.5-2-3.5-2.4 1a7.7 7.7 0 0 0-1.9-1.1L14.8 3h-5.6L8.9 5.9a7.7 7.7 0 0 0-1.9 1.1l-2.4-1-2 3.5 2 1.5A7.4 7.4 0 0 0 4.5 12c0 .4 0 .7.1 1.1l-2 1.5 2 3.5 2.4-1a7.7 7.7 0 0 0 1.9 1.1L9.2 21h5.6l.3-2.9a7.7 7.7 0 0 0 1.9-1.1l2.4 1 2-3.5-2-1.5c.1-.4.1-.7.1-1.1Z',
}

export function NavIcon({
  name,
  className,
}: {
  name: NavIconName
  className?: string
}) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d={paths[name]} />
    </svg>
  )
}
